const BACKEND = process.env.REACT_APP_BACKEND_URL;
const BASE = `${BACKEND}/api`;

import { getAuthToken } from "@/lib/api";

async function req(path, options = {}) {
  const token = getAuthToken();
  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });
  if (!res.ok) {
    let detail = "Ocorreu um erro. Tente novamente.";
    try {
      const d = await res.json();
      if (d && typeof d.detail === "string") detail = d.detail;
    } catch (e) {
      /* ignore */
    }
    throw new Error(detail);
  }
  return res.json();
}

export const getPricing = () => req("/products/pricing");
export const createOrder = (payload) =>
  req("/orders", { method: "POST", body: JSON.stringify(payload) });
export const createCheckout = (orderId, originUrl) =>
  req("/checkout/session", {
    method: "POST",
    body: JSON.stringify({ order_id: orderId, origin_url: originUrl }),
  });
export const getCheckoutStatus = (sessionId) =>
  req(`/checkout/status/${sessionId}`);
export const getOrder = (orderId) => req(`/orders/${orderId}`);

export function formatPrice(amount) {
  return new Intl.NumberFormat("pt-PT", {
    style: "currency",
    currency: "EUR",
  }).format(Number(amount || 0));
}
